import React from 'react';
import styled, {css} from 'styled-components';
import {Title} from '../../ui/BasMagazines/components/styled';
import RadioGroup from '../../ui/Forms/Inputs/RadioGroup';
import StarRatingButton from '../../ui/StarRating/StarRatingButton';
import {
  backgroundColor,
  bordersColor,
  complementaryColor,
  darkGrayColor,
  notificationErrorColor,
  notificationSuccessColor,
} from '../../ui/constants/colors';
import {desktopOnlyCss, mediaMinTablet} from '../../ui/constants/customMedia';
import {ElementLayers} from '../../ui/constants/layers';
import {
  fontSize12,
  fontSize16,
  fontSize20,
  fwBold,
} from '../../ui/constants/typography';
import {useProductReviewTranslations} from './context/ProductReviewTranslationsProvider';

export const IconWrapper = styled.div`
  margin: 12px auto 8px;
`;

export const SuccessIconWrapper = styled(IconWrapper)`
  svg {
    fill: ${notificationSuccessColor};
  }
`;

export const ErrorIconWrapper = styled(IconWrapper)`
  svg {
    fill: ${notificationErrorColor};
  }
`;

export const ModalTitle = styled.div`
  ${fontSize16}
  ${fwBold}
  margin: 0 0 8px;
  text-align: center;
  padding: 0 24px;
`;
export const ModalText = styled.div`
  color: ${darkGrayColor};
  ${fontSize12}
  text-align: center;
  padding: 0 24px 24px;
`;

export const REVIEW_IMAGE_WIDTH = 42;

export const FormRow = styled.div`
  margin-bottom: 16px;
`;

export const StyledProductImageWrapper = styled.div<{hasImage: boolean}>`
  ${desktopOnlyCss}
  width: 42px;
  height: 50px;
  margin-right: 16px;
  box-sizing: border-box;
  background: ${backgroundColor};
  ${props => (props.hasImage ? '' : 'display: none')}
`;

export const Panel = styled.div<{hasThumb?: boolean}>`
  border: 1px solid ${bordersColor};
  padding: 11px;
  ${props =>
    props.hasThumb &&
    css`
      @media ${mediaMinTablet} {
        display: flex;
      }
    `}
`;

export const StyledTitle = styled(Title)`
  margin: 0;
  &:not(:last-child) {
    margin: 0 0 13px;
  }
`;

export const RatingValueScale = styled.div`
  display: flex;
  justify-content: space-between;
  span {
    flex: 1 1 100%;
  }
  span:nth-child(3n) {
    text-align: right;
  }
  span:nth-child(3n + 2) {
    text-align: center;
  }
`;

export const ValuesList: React.FC<{
  values: readonly string[];
  currentValue: number;
}> = ({values, currentValue}) => {
  const {selectLabel} = useProductReviewTranslations();

  if (currentValue > 0 && currentValue <= values.length) {
    return <div>{values[currentValue - 1]}</div>;
  }

  return <div>{selectLabel}</div>;
};

export const RatingGroup = styled.div`
  color: ${darkGrayColor};
  ${fontSize12};

  fieldset {
    padding: 8px 0;
  }
`;

export const RatingTitle = styled.div`
  ${fontSize20}
  ${fwBold}
  text-align: center;
  margin-bottom: 24px;
  @media ${mediaMinTablet} {
    margin-bottom: 32px;
  }
`;

export const SubmitButtonRow = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 16px 0;
  text-align: center;
  background: ${complementaryColor};
  z-index: ${ElementLayers.toasts - 1};
  box-shadow: 0 -2px 2px 0 rgba(0, 0, 0, 0.04),
    0 -10px 15px 0 rgba(0, 0, 0, 0.05);

  display: flex;
  justify-content: center;

  button {
    width: auto;
    min-width: 0;
  }

  @media ${mediaMinTablet} {
    position: static;
    width: auto;
    box-shadow: unset;
  }
`;

export const FormFields = styled.div`
  padding: 24px 16px 16px;
`;

export const StyledStarRatingButton = styled(StarRatingButton)`
  margin-top: 8px;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  display: block;
  label:not(:last-child) {
    margin-bottom: 16px;
  }
`;
